AppConfig = require '../AppConfig'
ErrorModal = require './ErrorModal'
errorModal = null

###*
 * エラー用モーダル作成
###
setErrorModal = ->
  errorModal = new ErrorModal()


###*
 * エラー処理
 * @param  {String} message
###
error = (message)->
  errorModal.alert(message)

###*
 * ajax
 * @param  {Object} options {url: String, data, param callback: Function, failback: Function}
 * @return {jQuery.ajax}
###
ajax = (options)->
  self = @
  options = _.defaults (options || {}),
    type: 'POST'
    dataType: 'json'
    # timeout: 10000

  # ajax成功処理
  options.success = (data)->
    # api成功処理
    if data.result == 'SUCCESS'
      if $.isFunction(options.callback)
        options.callback.call(null, data)
      return

    # apiエラー処理
    if $.isFunction(options.failback)
      options.failback.call(null)
    if data.result == 'ERROR'
      error data.error
    else
      error ''

  # ajaxエラー処理
  options.error = (xhr, textStatus, errorThrown)->
    # # タイムアウトエラー
    # if textStatus == 'timeout'
    # # 404エラー
    # if xhr.status == 404

    # エラー処理
    if $.isFunction(options.failback)
      options.failback.call(null)
    error ''

  return $.ajax options

Api =
  getTopNewList:          (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_TOP_NEW_LIST          }, options)
  getArticleCategoryList: (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_ARTICLE_CATEGORY_LIST }, options)
  getArticleTagList:      (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_ARTICLE_TAG_LIST      }, options)
  getSearchKeywordList:   (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_SEARCH_KEYWORD_LIST   }, options)
  getTopicsList:          (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_TOPICS_LIST           }, options)
  getTopNewReaction:      (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_TOP_NEW_REACTION      }, options)
  getContentsReaction:    (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_CONTENTS_REACTION     }, options)
  getTopicsReaction:      (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_TOPICS_REACTION       }, options)
  getCommentReaction:     (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_COMMENT_REACTION      }, options)
  commentRegist:          (options)-> ajax $.extend(true, {url: AppConfig.API_URL.COMMENT_REGIST            }, options)
  commentDelete:          (options)-> ajax $.extend(true, {url: AppConfig.API_URL.COMMENT_DELETE            }, options)
  niceRegist:             (options)-> ajax $.extend(true, {url: AppConfig.API_URL.NICE_REGIST               }, options)
  getSendComment:         (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_SEND_COMMENT          }, options)
  getReceiveComment:      (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_RECEIVE_COMMENT       }, options)
  getSendNice:            (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_SEND_NICE             }, options)
  getReceiveNice:         (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_RECEIVE_NICE          }, options)
  topicsReport:           (options)-> ajax $.extend(true, {url: AppConfig.API_URL.TOPPICS_REPORT            }, options)
  getRecommendList:       (options)-> ajax $.extend(true, {url: AppConfig.API_URL.GET_RECOMMENTD_LIST       }, options)
  niceReadUpdate:         (options)-> ajax $.extend(true, {url: AppConfig.API_URL.NICE_READ_UPDATE          }, options)
  commentReadUpdate:      (options)-> ajax $.extend(true, {url: AppConfig.API_URL.COMMENT_READ_UPDATE       }, options)
  init: -> setErrorModal()

module.exports = Api



// WEBPACK FOOTER //
// ./src/scripts/modules/Api.coffee